import { DateTime } from 'luxon';

function formatDate(timestamp) {
  if (!timestamp) return '';
  return DateTime.fromISO(timestamp, { setZone: true })
    .toLocal()
    .setLocale('da')
    .toFormat('dd. MMM yyyy HH:mm:ss');
}

export default formatDate;
